import { defineMessages } from 'react-intl';

export const messages = {
  ...defineMessages({
    editStaffBlock: {
      id: 'appointments.block-off-time.edit-staff-block',
      defaultMessage: 'Edit staff block',
    },
    unavailablePractitioner: {
      id: 'appointments.block-off-time.unavailable-practitioner',
      defaultMessage: '{fullName} unavailable',
    },
    venueClosed: {
      id: 'appointments.block-off-time.venue-closed',
      defaultMessage: 'Venue closed',
    },
    rowTime: {
      id: 'appointments.block-off-time.row-time',
      defaultMessage: '{startTime, date, time} - {endTime, date, time}',
    },
    editBlock: {
      id: 'appointments.block-off-time.edit-block',
      defaultMessage: 'Edit block',
    },
    deleteBlock: {
      id: 'appointments.block-off-time.delete-block',
      defaultMessage: 'Delete block',
    },
    date: {
      id: 'appointments.block-off-time.form.date',
      defaultMessage: 'Date',
    },
    startTime: {
      id: 'appointments.block-off-time.form.start-time',
      defaultMessage: 'Start time',
    },
    endTime: {
      id: 'appointments.block-off-time.form.end-time',
      defaultMessage: 'End time',
    },
    startTimePlaceholder: {
      id: 'appointments.block-off-time.form.start-time-placeholder',
      defaultMessage: 'Select start time',
    },
    endTimePlaceholder: {
      id: 'appointments.block-off-time.form.end-time-placeholder',
      defaultMessage: 'Select end time',
    },
    staffDescription: {
      id: 'appointments.block-off-time.form.staff-description',
      defaultMessage: 'This will stop your staff from accepting new ClassPass bookings.',
    },
    fnbStaffDescription: {
      id: 'appointments.block-off-time.form.fnb-staff-description',
      defaultMessage: 'This will stop your staff from accepting new ClassPass orders.',
    },
    save: {
      id: 'appointments.block-off-time.form.save',
      defaultMessage: 'Save',
    },
    cancel: {
      id: 'appointments.block-off-time.form.cancel',
      defaultMessage: 'Cancel',
    },
    delete: {
      id: 'appointments.block-off-time.form.delete',
      defaultMessage: 'Delete',
    },
    startTimeAfterEndTime: {
      id: 'appointments.block-off-time.validator.start-time-after-end-time',
      defaultMessage: 'Start time cannot be later than end time.',
    },
    requiredField: {
      id: 'appointments.block-off-time.validator.required-field',
      defaultMessage: 'This field is required.',
    },
    bookableRequired: {
      id: 'appointments.block-off-time.validator.bookable-required',
      defaultMessage: 'A practitioner or equipment must be selected.',
    },
    dateInThePast: {
      id: 'appointments.block-off-time.validator.date-in-the-past',
      defaultMessage: 'Date cannot be in the past.',
    },
    descriptionLabel: {
      id: 'appointments.block-off-time.form.description-label',
      defaultMessage: 'Description',
    },
    addStaffButton: {
      id: 'appointments.block-off-time.form.add-staff-button',
      defaultMessage: 'Add staff',
    },
    emptyStateCopy: {
      id: 'appointments.block-off-time.form.empty-state-copy',
      defaultMessage: 'There are no practitioners associated with this venue',
    },
  }),
  success: defineMessages({
    blockOffTimeStaffAdded: {
      id: 'appointments.block-off-time.success.block-off-time-staff-added',
      defaultMessage: 'Staff block added.',
    },
    blockOffTimeStaffEdited: {
      id: 'appointments.block-off-time.success.block-off-time-staff-edited',
      defaultMessage: 'Staff block updated.',
    },
    blockOffTimeDeleted: {
      id: 'appointments.block-off-time.saga.success.block-off-time-deleted',
      defaultMessage: 'Block off time deleted.',
    },
  }),
  error: defineMessages({
    problemWithRequest: {
      id: 'appointments.block-off-time.error.problem-with-request',
      defaultMessage: 'There was a problem with your request.',
    },
  }),
  deleteModal: defineMessages({
    title: {
      id: 'appointments.block-off-time.delete-block-off-time-modal.title',
      defaultMessage: 'Delete block off time',
    },
    description: {
      id: 'appointments.block-off-time.delete-block-off-time-modal.description',
      defaultMessage: 'Are you sure you want to delete this block off time?',
    },
    cancel: {
      id: 'appointments.block-off-time.delete-block-off-time-modal.cancel',
      defaultMessage: 'Cancel',
    },
    confirm: {
      id: 'appointments.block-off-time.delete-block-off-time-modal.confirm',
      defaultMessage: 'Confirm',
    },
  }),
  confirmStaffBlockModal: defineMessages({
    title: {
      id: 'appointments.block-off-time.confirm-staff-block-modal.title',
      defaultMessage: 'Are you sure you want to block your staff during this time period?',
    },
    body: {
      id: 'appointments.block-off-time.confirm-staff-block-modal.body',
      defaultMessage:
        'Please note you may have already existing appointments during this time, and creating this staff block <strong>will not cancel these appointments</strong>. Please ensure you cancel these appointments if necessary after creating this staff block.',
    },
    cancel: {
      id: 'appointments.block-off-time.confirm-staff-block-modal.cancel',
      defaultMessage: 'Cancel',
    },
    confirm: {
      id: 'appointments.block-off-time.confirm-staff-block-modal.confirm',
      defaultMessage: 'Confirm',
    },
  }),
};
